<template>
    <card-list>
        <subheader-list-item icon="fa-ban" title="Override Event"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-switch :true-value="1" :false-value="0" v-model="event.active">Participant will attend this event.</b-switch>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Description/Notes" label-position="inside">
                        <b-input type="textarea" v-model="event.description"/>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-file-pdf" title="Documents"/>

        <!-- Documents on the trip event itself. Everyone on the trip gets these
             (subject to their Navigator toggle); they are edited on the trip event,
             not here, so the row opens the trip-level document card. -->
        <document-list-item
            v-for="doc in (tripEvent.documents || [])"
            :key="'trip-' + doc.id"
            :doc="doc"
            :card="card"
            :active="isActiveDoc(doc, false)"
            @click="$openCard('edit-event-document', {tripId: tripId, dayId: tripEvent.day_id, eventId: tripEvent.id, docId: doc.id}, card)"
        />

        <!-- Documents added just for this participant, on top of the trip ones. -->
        <document-list-item
            v-for="doc in (event.documents || [])"
            :key="'own-' + doc.id"
            :doc="doc"
            :card="card"
            personal
            :active="isActiveDoc(doc, true)"
            @click="$openCard('edit-event-document', {tripId: 'null', registrationId: registrationId, dayId: event.day_id, eventId: event.id, docId: doc.id, type: 'custom-event'}, card)"
        />

        <container-list-item padded v-if="!event.id">
            <i class="far fa-info-circle mr-3 ml-2 fa-fw"/>Please save this customization before adding documents.
        </container-list-item>
        <container-list-item padded v-else-if="!documentCount">
            <i class="far fa-info-circle mr-3 ml-2 fa-fw"/>No event documents.
        </container-list-item>
    </card-list>
</template>

<script>
    import debounce from 'debounce';
    import {client as http} from '../../http_client';
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import DocumentListItem from "../../components/DocumentListItem.vue";


    export default {
        name: 'OverrideForm',
        props: {
            event: {
                type: Object,
                required: true
            },
            // The trip event being customized, with its own documents.
            tripEvent: {
                type: Object,
                default: () => ({})
            },
            tripId: {
                required: false
            },
            registrationId: {
                required: false
            },
            card: {
                required: false
            },
            child: {
                required: false
            }
        },
        components: {DocumentListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function () {
            return {

            };
        },
        computed: {
            documentCount: function () {
                return ((this.tripEvent.documents || []).length + (this.event.documents || []).length);
            }
        },
        methods: {
            // Trip and personalized documents are numbered from different tables, so the
            // open card is only "this" document if it came from the same list.
            isActiveDoc: function (doc, personal) {
                if (!this.child || this.child.definition.component !== 'edit-event-document') return false;
                return this.child.props.docId === doc.id.toString() && ((this.child.props.type === 'custom-event') === personal);
            }
        }
    };
</script>
